<template>
  <ul class="sign-process" :class="[{ 'sign-process--flex': data.length <= maxNum }, { scroll: data.length > maxNum }, customClass]">
    <li
      v-for="(item, idx) in formatData"
      :key="idx"
      class="sign-process__item"
      :class="[{ 'sign-process__item--flex': data.length <= maxNum }, { 'sign-process__item--20': data.length > maxNum }]"
    >
      <div class="sign-process__item__content">
        <div v-if="item.isPlaceholder" class="sign-process__item__content__middle" />

        <template v-else>
          <div class="sign-process__item__content__top">
            <span>${{ item.money }}</span>

            <button
              v-if="item.status === 1"
              class="get_gift no_get active"
              type="button"
              @click="getAward(item.receiveId)"
            >
              Receive
            </button>
            <span v-else-if="item.status === 2" class="get_gift over">Received</span>
            <span v-else class="get_gift no_get">Pending</span>
          </div>

          <div class="coin">{{ item.coin }}</div>

          <div
            class="sign-process__item__content__middle"
            :class="{ 'sign-process__item__content__middle--active': active >= item.dayNumber }"
          />

          <div class="sign-process__item__content__bottom">Day {{ item.dayNumber }}</div>
        </template>
      </div>

      <div v-if="formatData.length - 1 !== idx" class="tail" />
    </li>
  </ul>
</template>

<script>
import { getUserCumulative } from "../recovered/sign-api";

export default {
  name: "SignProcess",
  props: {
    customClass: String,
    id: Number,
    active: {
      type: Number,
      default: -1,
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    maxNum: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    formatData() {
      const diff = this.maxNum - this.data.length;
      if (diff <= 0) return this.data;
      return [...this.data, ...new Array(diff).fill({ isPlaceholder: true })];
    },
  },
  methods: {
    async getAward(receiveId) {
      if (!this.id || !receiveId) return;

      try {
        await getUserCumulative(this.id, receiveId);
        this.$emit("init");
      } catch (err) {
        // Keep component non-blocking; parent may show global message.
        // eslint-disable-next-line no-console
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
.sign-process {
  display: flex;
  gap: 8px;
  list-style: none;
  padding: 0;
  margin: 0;
}
.scroll {
  overflow-x: auto;
}
.sign-process__item {
  min-width: 120px;
}
.sign-process__item__content {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 8px;
}
.sign-process__item__content__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.get_gift {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 999px;
  border: none;
}
.get_gift.no_get {
  background: #ececec;
}
.get_gift.no_get.active {
  background: #0dad51;
  color: #fff;
  cursor: pointer;
}
.get_gift.over {
  background: #efefef;
  color: #666;
}
.coin {
  margin-top: 4px;
  font-size: 12px;
  color: #666;
}
.sign-process__item__content__middle {
  margin: 8px 0;
  height: 4px;
  border-radius: 99px;
  background: #e5e5e5;
}
.sign-process__item__content__middle--active {
  background: #0dad51;
}
.sign-process__item__content__bottom {
  font-size: 12px;
  color: #444;
}
.tail {
  display: none;
}
</style>
